import Popover from '../../../../../components/Popover';
import React from 'react';
import { IDashboardMediaPopoverProps } from './types';
import { DashboardMediaForm } from './DashboardMediaForm';

export const DashboardMediaPopover = ({
  isOpen,
  onClose,
  anchorPosition,
  url,
  onSubmit,
  mode,
}: IDashboardMediaPopoverProps) => {
  const handleSubmit: typeof onSubmit = (url) => {
    onSubmit(url);
    onClose();
  };

  return (
    <Popover
      isOpen={isOpen}
      close={onClose}
      anchorPosition={anchorPosition}
      anchorReference="anchorPosition"
    >
      {isOpen && (
        <DashboardMediaForm
          url={url}
          mode={mode}
          onSubmit={handleSubmit}
          onCancel={onClose}
        />
      )}
    </Popover>
  );
};
